import { Suspense, lazy } from 'react'
import { EventCountdownTimeDateContainer } from '@nv/components'
import BalletBox from '@nv/images/design/ballet-box-icon'
import DividerIcon from '@nv/images/design/divider-icon'
import { useTranslation } from 'react-i18next'
import Skeleton from '../../skeleton/Skeleton'
import styles from './AdminEventContent.module.scss'

const EventStatus = lazy(() => import('../event_status/EventStatus'))
const LazyNVButton = lazy(() => import('@nv/basic-components').then((module) => ({ default: module.NVButton })))

export const AdminEventContent = ({
  event,
  title,
  votingOpen,
  onSelectEvent,
  isHeader = false,
  hasVoted = false,
}: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <div className={styles['content']}>
          <BalletBox className={styles['svg']} />

          <div className={styles['title']}>
            <h3 className={styles['label']}>{title[currentLanguage]}</h3>

            <div className={styles['positions']}>
              <Suspense fallback={<><Skeleton width={120} /><Skeleton width={100} /></>}>
                <EventStatus
                  votingOpen={votingOpen}
                  eventState={event.state}
                  nominationState={event.nominationState}
                  hasVoted={hasVoted}
                />
                <DividerIcon style={{ margin: '0 1.25rem' }} />
                <span className={styles['positions--text']}>
                  {event.questions?.length} {t('events.labels.positions')}
                </span>
              </Suspense>
            </div>

            {!isHeader && (
              <Suspense fallback={<Skeleton width={80} height={37} />}>
                <LazyNVButton text={t('main.details')} height={37} onClick={() => onSelectEvent(event)} />
              </Suspense>
            )}
          </div>
        </div>

        <Suspense fallback={<><Skeleton width={150} /><Skeleton width={100} /></>}>
          <EventCountdownTimeDateContainer event={event} votingOpen={votingOpen} />
        </Suspense>
      </div>
    </div>
  )
}
